(function () {
  try {
    // Only run on product pages
    if (window.location.pathname.indexOf('/products/') === -1) return;

    // Generate or retrieve persistent session ID
    var sid = localStorage.getItem('bk_sid');
    if (!sid) {
      sid = 'bk_' + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11)
        .replace(/[018]/g, function (c) {
          return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
        });
      localStorage.setItem('bk_sid', sid);
    }

    // Extract product handle from pathname: /products/<handle>
    var parts = window.location.pathname.split('/products/');
    var handle = parts[1] ? parts[1].split('/')[0].split('?')[0] : null;
    if (!handle) return;

    // UTM params: read from URL or fall back to sessionStorage
    var search = window.location.search;
    var params = new URLSearchParams(search);
    var utmSource   = params.get('utm_source')   || sessionStorage.getItem('bk_utm_source')   || '';
    var utmMedium   = params.get('utm_medium')   || sessionStorage.getItem('bk_utm_medium')   || '';
    var utmCampaign = params.get('utm_campaign') || sessionStorage.getItem('bk_utm_campaign') || '';
    if (params.get('utm_source'))   sessionStorage.setItem('bk_utm_source',   utmSource);
    if (params.get('utm_medium'))   sessionStorage.setItem('bk_utm_medium',   utmMedium);
    if (params.get('utm_campaign')) sessionStorage.setItem('bk_utm_campaign', utmCampaign);

    // Customer email (set by theme.liquid only for logged-in customers)
    var email = (window.BASKETEER_CUSTOMER_EMAIL || '').trim();

    var payload = {
      session_id:     sid,
      product_handle: handle,
      customer_email: email || undefined,
      utm_source:     utmSource || undefined,
      utm_medium:     utmMedium || undefined,
      utm_campaign:   utmCampaign || undefined
    };

    fetch('https://app.basketeer.com/api/browse-event', {
      method:    'POST',
      headers:   { 'Content-Type': 'application/json' },
      keepalive: true,
      body:      JSON.stringify(payload)
    }).catch(function(){});
  } catch (_) {
    // Never affect storefront
  }
})();
